module.exports = __webpack_public_path__ + "images/_/programs/epsPrimaries/images/characters/ian_pointing_up-bba09e13f5577e652503b9d51f9542fe.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/images/characters/ian_pointing_up.png
// module id = 423
// module chunks = 2